/**
 * Canonical PostHog event names and the mapping from the existing internal
 * (Customer.io) event catalogue. Keeping one mapping table means every
 * producer already instrumented in the app reaches PostHog through a single
 * fan-out point — no second set of call sites, therefore no duplicates.
 */
import { CIO_EVENTS } from "@/lib/customerio/events";

export const PH_EVENT_BY_CIO: Record<string, string> = {
  [CIO_EVENTS.PRODUCT_VIEWED]: "product_viewed",
  [CIO_EVENTS.COLLECTION_VIEWED]: "collection_viewed",
  [CIO_EVENTS.CATEGORY_VIEWED]: "collection_viewed",
  [CIO_EVENTS.ADD_TO_CART]: "add_to_cart",
  [CIO_EVENTS.CART_UPDATED]: "cart_updated",
  [CIO_EVENTS.REMOVE_FROM_CART]: "cart_updated",
  [CIO_EVENTS.CHECKOUT_STARTED]: "checkout_started",
  [CIO_EVENTS.PAYMENT_SUCCESS]: "payment_success",
  [CIO_EVENTS.PAYMENT_FAILED]: "payment_failed",
  [CIO_EVENTS.ORDER_CREATED]: "order_created",
  [CIO_EVENTS.ORDER_CONFIRMED]: "order_confirmed",
  [CIO_EVENTS.ORDER_PACKED]: "order_packed",
  [CIO_EVENTS.ORDER_SHIPPED]: "order_shipped",
  [CIO_EVENTS.ORDER_DELIVERED]: "order_delivered",
  [CIO_EVENTS.SEARCH_PERFORMED]: "search_performed",
  [CIO_EVENTS.USER_REGISTERED]: "user_registered",
  [CIO_EVENTS.USER_LOGIN]: "user_logged_in",
  [CIO_EVENTS.WISHLIST_ADDED]: "wishlist_added",
};

/** Resolve the PostHog name for an internal event, or null to skip it. */
export function toPostHogEvent(name: string): string | null {
  return PH_EVENT_BY_CIO[name] ?? null;
}